import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
`;

export const SubLevelLabel = styled.div`
    margin-top: 1px;
`;

export const LevelLabel = styled.div`
    font-weight: bold;
`;

export const WrapperIcon = styled.div`
    display: flex;
    flex-direction: row;
    margin-left: 5px;
`;

export const LabelIcon = styled.div`
    margin-top: 3px;
    margin-right: 5px;
`;

export const StylesToolTip = {
    'white-space': 'pre-line',
    width: '200px',
    'text-align': 'left',
};
